import { Button, Divider, Modal, Text } from '@hopskipdrive/react-components';

export const AssignDriverModal = ({
  isOpen,
  isPending,
  selectedDriver,
  setSelectedDriver,
  setQuery,
  setDriverQuery,
  setAssignDriverModalOpen,
  handleAssignDriverSubmit,
}) => {
  const handleCancelAssignDriver = () => {
    setDriverQuery('');
    setQuery('');
    setAssignDriverModalOpen(false);
    setSelectedDriver(null);
  };

  return (
    <Modal open={isOpen}>
      <Modal.Title>Assign Driver</Modal.Title>
      <Modal.Content>
        <Text variant="body1" textColor="secondaryText">
          Are you sure you want to assign {selectedDriver.firstName} {selectedDriver.lastName} as the driver on this
          ride?
        </Text>
      </Modal.Content>
      <Divider />
      <Modal.Actions>
        <Button color="tonal" disabled={isPending} onClick={() => handleCancelAssignDriver()}>
          Never mind
        </Button>
        <Button color="primary" onClick={() => handleAssignDriverSubmit(selectedDriver)} loading={isPending}>
          {isPending ? 'Assigning...' : 'OK'}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
